// extracted by mini-css-extract-plugin
export default {"price-container":"prices_price-container__vKluM","price-table":"prices_price-table__2BBSi","vertical-text":"prices_vertical-text__qrb2W","empty-cell":"prices_empty-cell__lvQqI"};